import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch, ReactReduxContext } from "react-redux";
import { RotatingLines } from "react-loader-spinner";
import Constants from "../Constants";
import jQuery from "jquery";
import ReactTooltip from "react-tooltip";
import { updateTab, setTreeLoading, removeFromSelectedTreeData, addToSelectedTreeData, updateSelectedTreeNode, updateSearchText, updateTreeValue, updateWidthChanges } from "../redux/reducers/TreeSlice";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { isMarketingProgram } from "../services/IntegrationUtil";
import { updateCanSubmitTranslation, updateReadyForValidation, updateValidationErrors} from "../redux/reducers/AsyncAssetUploadSlice";
import { updateProjectInfo } from "../redux/reducers/ProjectInfoSlice";
import { ConditionalBlock } from "../ConditionalBlock";
import TreeResizeBar from "./TreeResizeBar";
const TreeView = (props) => {
  const { t } = useTranslation();
  const translate = t;
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const theme = aaaSelected ? "dark" : "";
  const dispatch = useDispatch();
  const searchTextRef = useRef(null);
  const treeData = useSelector((redux) => redux.tree_structure).treeData;
  const tabs = useSelector((redux) => redux.tree_structure).tabs;
  const selectedTreeData = useSelector((redux) => redux.tree_structure).selectedTreeData;
  const treeValueRedux = useSelector((redux) => redux.tree_structure).treeValue;
  const projectAssetType = useSelector((redux) => redux.asset_type_for_project_creation).value;
  const custBootstrapDataRedux = useSelector((store) => store.customer_bootstrap_data).value;
  const projectRequestIntegrationRedux = useSelector((redux) => redux.project_request_integration).value;
  const validationErrors = useSelector(reduxStore => reduxStore.asset_upload_background).value.validationErrors;
  const projectData = useSelector((reduxStore) => reduxStore.project_info).value;
  const [checked, setChecked]=useState(false);
  const dispatchDataToTreeSliceRedux = (type, value) => {
    dispatch(
      updateTreeValue({
        type: type,
        value: value,
      })
    );
  };
  
  useEffect(()=> {
    setChecked(projectData?.scanImage);
    if(projectData?.scanImage===true && treeValueRedux?.scanImgforTranslation!= true)
    {
     dispatchDataToTreeSliceRedux("scanImgforTranslation",projectData?.scanImage)
    }
  },[projectData])

  const brightcoveSearchTypeOptions = [{ value: "VIDEO", label: "Video" }];

  const onTabChange = (tab) => {
    let cloneTabs = JSON.parse(JSON.stringify(tabs));
    cloneTabs.map((t) => {
      if (t.name === tab.name) {
        t.isActive = true;
      } else {
        t.isActive = false;
      }
    });
    dispatch(updateTab(cloneTabs));
    props.onTabChange(tab);
  };

  const deleteSelectedAsset = (asset) => {
    dispatch(removeFromSelectedTreeData(asset));
    const updatedSourceAssets = selectedTreeData.filter((sourceFile) => sourceFile.name !== asset.name);
    const updatedValidationErrors = validationErrors.filter((validation) => validation.name !== asset.name);
    const hasFailedValidation = updatedValidationErrors.some((validation) => validation.status === "fail");
    dispatch(updateValidationErrors(updatedValidationErrors));
    dispatch(updateCanSubmitTranslation(!hasFailedValidation && updatedSourceAssets.length !== 0));
    dispatch(updateWidthChanges(getTreeWidthChanges()));
  };

  const onSearchTextClick = () => {
   dispatch(updateSearchText(searchTextRef?.current?.value));
  };

  const onSearchTextSubmit = (e) => {
    if (e?.key === 'Enter') {
      onSearchTextClick();
    }
  };

  const onChangeSearchType = (event) => {
    dispatchDataToTreeSliceRedux("searchTypeValue", event.value);
  };

  const onSelectImageCheckBox = (e) => {
    setChecked(e.target.checked);
    dispatchDataToTreeSliceRedux("scanImgforTranslation", e.target.checked);
    dispatch(updateProjectInfo({
      type: "scanImage",
      value: e.target.checked
    }));
  };

  const setIncludeDependencies = (e) => {
    dispatchDataToTreeSliceRedux("includeDependencies", e.target.checked);
  }

  const onDeliveryTypeChange = (e) => {
    props.changeDeliveryType(e.value)
  }

  const treeMaxHeight = calTreeMaxHeight(treeData, 37.25);
  return (
    <>
      <div className={treeValueRedux.isTreeLoading ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines strokeColor="#0096FF" strokeWidth="5" width="196" visible={true} />
        </div>
      </div>

      <div>
        <div className="step-1-section">
          <div className="marketo-folder-content">
            <div className="marketo-top-heading flex-center">
                <h4>
            {treeValueRedux?.assetType === "EMAIL_HEADER"
              ? translate("other_integrations_project_creation.Email_Header")
              : treeValueRedux?.assetType === "EMAIL_FOOTER"
              ? translate("other_integrations_project_creation.Email_Footer")
              : translate("other_integrations_project_creation.source_material_for")}
              </h4>
              <ConditionalBlock condition={!(treeValueRedux?.assetType === "EMAIL_HEADER" || treeValueRedux?.assetType === "EMAIL_FOOTER" )}>
              <button className="readonly" tabIndex="-1">
                {treeValueRedux.contentType}
              </button>
              </ConditionalBlock>
            </div>
            <div>
              {treeValueRedux.contentType === Constants.ELOQUA_CONTENT_TYPE_DISPLAY &&
                projectAssetType === Constants.STATIC && !(props.isElouquaSettingPage && props.isElouquaSettingPage === 'true') && 
                (treeValueRedux.defaultEloquaContact === undefined || treeValueRedux.defaultEloquaContact === null) && (
                  <p className="alert">
                    <span className="alert-icon" />
                    <span className="padd-lr">
                      {custBootstrapDataRedux?.permissions[Constants.ELOQUA_ACCESS_CHANGE_GRANT] !== undefined && custBootstrapDataRedux?.permissions[Constants.ELOQUA_ACCESS_CHANGE_GRANT] === true ? (
                        <>
                          To enable viewing translated Eloqua assets in OneReview, please
                          <a id="eloqua-select-contact" href="/settings/integration-setting-eloqua-integration">
                            {" "}
                            select{" "}
                          </a>{" "}
                          an Eloqua contact to preview as.
                        </>
                      ) : (
                        <>To enable viewing translated Eloqua assets in OneReview, please contact your organization's administrator to set an Eloqua contact to preview as.</>
                      )}
                    </span>
                  </p>
                )}
            </div>

            <div className="folder-content-wrap flex">
              <div className="left-content">
                <div className="listing-tab-block marketo-tab flex">
                  <ul className="listing-tab-link flex width-auto" role="tablist">
                    {tabs.map((tab) => {
                      return (
                        <li role="none">
                          <button key={tab.name}
                            className={tab.isActive ? "active" : ""}
                            role="tab"
                            aria-label={tab.isActive ? "Current tab," +tab.label : tab.label}
                            aria-selected={tab.isActive ? "true" : "false"}
                            onClick={() => onTabChange(tab)}>
                            {tab.label}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                  <div className="right flex">
                    {(treeValueRedux.contentType === "Eloqua" || treeValueRedux.contentType === "Brightcove") && (
                      <div className="search">
                        <input
                          type="text"
                          className="search-control"
                          placeholder="Search Content"
                          ref={searchTextRef}
                          defaultValue={tabs.find((tab) => tab.isActive)?.searchText}
                          onKeyDown={onSearchTextSubmit}
                        />
                        <button type="submit" className="submit" aria-label="search" onClick={(e) => onSearchTextClick()}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                              d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                              stroke="#6C757D"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"></path>
                            <path d="M13.9996 13.9996L11.0996 11.0996" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                          </svg>
                        </button>
                      </div>
                    )}
                    {treeValueRedux.contentType === "Brightcove" && (
                      <div className="global-dropdown-block Brightcove-dropdown mb-0">
                        <Select
                          className="global-dropdown-select"
                          menuShouldScrollIntoView={false}
                          closeMenuOnSelect={true}
                          classNamePrefix="cw"
                          defaultValue={treeValueRedux.searchTypeValue}
                          aria-label="Select search type"
                          options={brightcoveSearchTypeOptions}
                          value={brightcoveSearchTypeOptions.filter(function (option) {
                            return option.value === treeValueRedux.searchTypeValue;
                          })}
                          onChange={(e) => onChangeSearchType(e)}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="folder-hierarchy-block" style={{ maxHeight: "475px", overflowY: "auto" }}>
                  <Tree treeValue={treeData} isElouquaSettingPage = {props.isElouquaSettingPage} level={0} maxHeight ={treeMaxHeight}/>
                </div>
                {treeValueRedux.contentType === "Eloqua" && !(props.isElouquaSettingPage && props.isElouquaSettingPage === 'true') && (
                  <div className="form-check bottom-chk">
                    <input className="form-check-input" type="checkbox" name="checkbox" value="" id="includeDependenciesCheckbox" 
                    defaultChecked={treeValueRedux.includeDependencies === true} onChange={e => setIncludeDependencies(e)}/>
                    <label className="form-check-label" htmlFor="includeDependenciesCheckbox">
                      Translate dependent forms and dynamic content embedded within your selected landing pages and emails.
                    </label>
                  </div>
                )}
              </div>
              <div className="right-content">
                {(props.deliveryTypes && props.deliveryTypes.length > 0) && 
                  <><label>{translate("other_integrations_project_creation.change_delivery_type")}</label>
                  <div className="global-dropdown-block mb-0">
                    <Select
                      className="global-dropdown-select"
                      menuShouldScrollIntoView={false}
                      closeMenuOnSelect={true}
                      classNamePrefix="cw"
                      aria-label="Change Delivery Type"
                      options={props.deliveryTypes}
                      value={props.deliveryTypes?.filter(function (option) {
                        return option.isSelected === true;
                      })}
                      onChange={(e) => onDeliveryTypeChange(e)}
                    />
                  </div></>
                }
                <div className="asset-selection-box">
                  <strong>Asset Selection</strong>
                  {selectedTreeData?.map((asset) => {
                    return (
                      asset && asset.assetType !== Constants.IMAGE && (
                        <button key={asset.id} aria-label="Regular Email delete" onClick={() => deleteSelectedAsset(asset)}>
                          <span>{asset[treeValueRedux.displayName]}</span>
                          <i>
                            <svg width="18" height="18">
                              <use href="#delete-icon"></use>
                            </svg>
                          </i>
                        </button>
                      )
                    );
                  })}
                </div>
                {!projectRequestIntegrationRedux.isProjectRequest && 
                !(props.isElouquaSettingPage && props.isElouquaSettingPage === 'true') &&
                treeValueRedux.contentType === Constants.ELOQUA_CONTENT_TYPE_DISPLAY && 
                projectAssetType === Constants.STATIC && (

                  <div className="form-check bottom-chk">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="checkbox"
                      id="eloqua-img-chk"
                      checked={checked}
                      onChange={(e) => onSelectImageCheckBox(e)}
                    />

                    <label className="form-check-label" htmlFor="eloqua-img-chk">
                      Scan for images to be translated
                    </label>
                    <div className="gb-tooltip" role="tooltip" aria-label="tooltip content" tabindex="0" aria-expanded="false">
                      <span>
                        <svg className="svg-tooltip-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                          <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                        </svg>
                      </span>
                      <div className="wrap-tooltip-content">
                        <div className="gb-tooltip-content">
                          <div className="triangle"></div>
                          <strong>Scan for images to be translated</strong>
                          <p>
                            Check this box to scan your selected assets for potential images to be translated. You will be prompted to upload a translatable image source file for each image you want
                            translated.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" style={{ display: "none" }}>
          <symbol id="arrow" viewBox="0 0 8 12" width="8" height="12">
            <path d="M0.59 1.41L5.17 6L0.59 10.59L2 12L8 6L2 0L0.59 1.41Z" fill="#AEBCDA" />
          </symbol>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" style={{ display: "none" }}>
          <symbol id="level-first" viewBox="0 0 20 20">
            <g data-name="Workspace">
              <path d="M10 0a10 10 0 1010 10A10 10 0 0010 0zm8.088 9.412h-3.277a15.953 15.953 0 00-.5-3.529h2.675a8.045 8.045 0 011.102 3.529zM16.14 4.706h-2.2a8.636 8.636 0 00-1.294-2.376 8.155 8.155 0 013.494 2.376zm-6.728 5.882v3.529H6.9a14.594 14.594 0 01-.536-3.529zM6.365 9.412a14.594 14.594 0 01.535-3.53h2.512v3.53zm4.223 1.176h3.046a14.594 14.594 0 01-.536 3.529h-2.51zm0-1.176v-3.53H13.1a14.594 14.594 0 01.536 3.529zm2.1-4.706h-2.1V2.129a4.605 4.605 0 012.099 2.577zM9.412 2.129v2.577h-2.1a4.605 4.605 0 012.1-2.577zm-2.059.2a8.636 8.636 0 00-1.291 2.377H3.86a8.155 8.155 0 013.493-2.377zM3.016 5.882h2.675a15.953 15.953 0 00-.5 3.529H1.912a8.045 8.045 0 011.1-3.529zm-1.1 4.706h3.273a15.953 15.953 0 00.5 3.529H3.016a8.045 8.045 0 01-1.1-3.529zm1.944 4.706h2.2a8.636 8.636 0 001.291 2.376 8.155 8.155 0 01-3.491-2.376zm3.453 0h2.1v2.577a4.605 4.605 0 01-2.1-2.577zm3.275 2.577v-2.577h2.1a4.605 4.605 0 01-2.1 2.577zm2.059-.2a8.636 8.636 0 001.294-2.376h2.2a8.155 8.155 0 01-3.494 2.376zm4.336-3.553h-2.674a15.953 15.953 0 00.5-3.529h3.277a8.045 8.045 0 01-1.102 3.529z"></path>
              <path d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm-.588 4.706V2.129c-.77.317-1.53 1.224-2.1 2.577h2.1zm3.275 0c-.57-1.353-1.33-2.26-2.099-2.577v2.577h2.1zm-6.625 0a8.636 8.636 0 011.29-2.377A8.155 8.155 0 003.86 4.706h2.202zm6.585-2.377c.554.72.99 1.522 1.294 2.377h2.199a8.155 8.155 0 00-3.493-2.377zM1.912 9.412H5.19c.035-1.192.204-2.376.502-3.53H3.016a8.045 8.045 0 00-1.104 3.53zm7.5 0v-3.53h-2.51a14.594 14.594 0 00-.537 3.53h3.047zm4.223 0a14.594 14.594 0 00-.536-3.53h-2.51v3.53h3.046zm.674-3.53c.298 1.154.467 2.338.502 3.53h3.277a8.045 8.045 0 00-1.104-3.53h-2.675zM5.69 14.118a15.953 15.953 0 01-.502-3.53H1.912a8.045 8.045 0 001.104 3.53h2.675zm3.72 0v-3.53H6.366a14.64 14.64 0 00.536 3.53h2.51zm3.688 0a14.64 14.64 0 00.536-3.53h-3.047v3.53h2.51zm3.885 0a8.045 8.045 0 001.104-3.53H14.81a15.953 15.953 0 01-.502 3.53h2.675zM3.86 15.294a8.155 8.155 0 003.493 2.377 8.636 8.636 0 01-1.291-2.377H3.86zm3.453 0c.57 1.353 1.33 2.26 2.099 2.577v-2.577h-2.1zm3.275 2.577c.77-.317 1.53-1.224 2.1-2.577h-2.1v2.577zm2.06-.2a8.155 8.155 0 003.495-2.377H13.94a8.636 8.636 0 01-1.294 2.377z"></path>
            </g>
          </symbol>
          {/* <symbol id="level-first" viewBox="0 0 14 14" width="14" height="14">
          <path
            d="M7 0C5.61553 0 4.26216 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.00303299 5.6003 -0.13559 7.00777 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.39971 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C14 5.14349 13.2625 3.36301 11.9498 2.05025C10.637 0.737498 8.85652 0 7 0V0ZM12.6616 6.5884H10.3677C10.3437 5.75448 10.2263 4.92588 10.0177 4.1181H11.8902C12.3356 4.87049 12.5997 5.71625 12.6616 6.5884ZM11.298 3.2942H9.758C9.54533 2.69565 9.23964 2.13437 8.8522 1.631C9.79943 1.9609 10.643 2.53455 11.298 3.2942ZM6.5884 7.4116V9.8819H4.83C4.60433 9.07692 4.47832 8.24728 4.4548 7.4116H6.5884ZM4.4555 6.5884C4.47873 5.75251 4.60451 4.92264 4.83 4.1174H6.5884V6.5884H4.4555ZM7.4116 7.4116H9.5438C9.52029 8.24728 9.39428 9.07692 9.1686 9.8819H7.4116V7.4116ZM7.4116 6.5884V4.1174H9.17C9.39568 4.92238 9.52169 5.75202 9.5452 6.5877L7.4116 6.5884ZM8.8816 3.2942H7.4116V1.4903C8.10885 1.88773 8.63278 2.53096 8.8809 3.2942H8.8816ZM6.5884 1.4903V3.2942H5.1184C5.3667 2.53084 5.89089 1.88759 6.5884 1.4903ZM5.1471 1.6303C4.76034 2.13402 4.45537 2.69554 4.2434 3.2942H2.702C3.35671 2.5344 4.20005 1.9605 5.1471 1.6303ZM2.1112 4.1174H3.9837C3.77513 4.92518 3.65773 5.75378 3.6337 6.5877H1.3384C1.39985 5.71566 1.66348 4.86991 2.1084 4.1174H2.1112ZM1.3412 7.4116H3.6323C3.65633 8.24552 3.77373 9.07413 3.9823 9.8819H2.1112C1.66628 9.12939 1.40265 8.28364 1.3412 7.4116ZM2.702 10.7058H4.242C4.45403 11.3042 4.759 11.8655 5.1457 12.369C4.19923 12.0388 3.35641 11.4651 2.702 10.7058ZM5.1191 10.7058H6.5891V12.5097C5.89159 12.1124 5.3674 11.4692 5.1191 10.7058ZM7.4116 12.5097V10.7058H8.8816C8.6333 11.4692 8.10912 12.1124 7.4116 12.5097ZM8.8529 12.3697C9.24034 11.8663 9.54603 11.305 9.7587 10.7065H11.2987C10.6437 11.4661 9.80013 12.0398 8.8529 12.3697ZM11.8881 9.8826H10.0163C10.2249 9.07483 10.3423 8.24622 10.3663 7.4123H12.6602C12.5983 8.28445 12.3342 9.13022 11.8888 9.8826H11.8881Z"
            fill="#FF6712"
          />
        </symbol> */}
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" style={{ display: "none" }}>
          <symbol id="folder-icon" width="16" height="16" viewBox="0 0 16 16">
            <g clipPath="url(#clip0_1753_21281)">
              <path
                d="M15.5004 13.8816H0.500391C0.473869 13.8816 0.448434 13.8711 0.42968 13.8524C0.410926 13.8336 0.400391 13.8082 0.400391 13.7816V2.28164C0.400391 2.12251 0.463605 1.9699 0.576127 1.85738C0.688648 1.74485 0.841261 1.68164 1.00039 1.68164H5.96519C6.12759 1.68164 6.28519 1.74804 6.39719 1.86404L8.04759 3.56404L8.16519 3.68564H8.33479L15.5004 3.68164C15.5556 3.68164 15.6004 3.72644 15.6004 3.78164V13.7816C15.6004 13.8082 15.5899 13.8336 15.5711 13.8524C15.5523 13.8711 15.5269 13.8816 15.5004 13.8816Z"
                fill="#F5C24C"
              />
              <path
                d="M1 2.08125C0.946957 2.08125 0.896086 2.10232 0.858579 2.13983C0.821071 2.17734 0.8 2.22821 0.8 2.28125V13.4812H15.2V4.08125L8.3344 4.08525H7.996L7.76 3.84205L6.1096 2.14205C6.09076 2.12274 6.06824 2.10741 6.04336 2.09697C6.01849 2.08653 5.99178 2.08118 5.9648 2.08125H1ZM5.9656 1.28125C6.2368 1.28125 6.496 1.39085 6.684 1.58525L8.3344 3.28525L15.5 3.28125C15.776 3.28125 16 3.50525 16 3.78125V13.7812C16 14.0573 15.776 14.2812 15.5 14.2812H0.5C0.367392 14.2812 0.240215 14.2286 0.146447 14.1348C0.0526784 14.041 0 13.9139 0 13.7812L0 2.28125C0 1.72925 0.448 1.28125 1 1.28125H5.9656Z"
                fill="#C99418"
              />
            </g>
            <defs>
              <clipPath id="clip0_1753_21281">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </symbol>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" style={{ display: "none" }}>
          <symbol id="open-folder-icon" width="18" height="14" viewBox="0 0 18 14">
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M14.7156 5.67188V5.97188H15.0156H17.125C17.305 5.97188 17.45 6.11686 17.45 6.29688C17.45 6.33805 17.4419 6.38051 17.4264 6.42027C17.4263 6.42054 17.4261 6.42082 17.426 6.4211L14.8098 12.903C14.7602 13.0256 14.6401 13.1062 14.5078 13.1062H0.875C0.694982 13.1062 0.55 12.9613 0.55 12.7812V1.21875C0.55 1.03873 0.694982 0.89375 0.875 0.89375H5.78197L8.03091 3.04492L8.1179 3.12812H8.23828H14.3906C14.5706 3.12812 14.7156 3.27311 14.7156 3.45312V5.67188ZM13.6094 5.97188H13.9094V5.67188V4.23438V3.93437H13.6094H7.79421L5.54526 1.78321L5.45827 1.7H5.33789H1.65625H1.35625V2V9.5625L1.93446 9.67475L3.34642 6.1751C3.34646 6.17502 3.34649 6.17494 3.34652 6.17486C3.39621 6.05244 3.51628 5.97188 3.64844 5.97188H13.6094Z"
              fill="#F5C24C"
              stroke="#C99318"
              strokeWidth="0.6"
            />
          </symbol>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" style={{ display: "none" }}>
          <symbol id="delete-icon" width="18" height="18" viewBox="0 0 18 18">
            <path
              d="M10.0253 1.9747C10.2854 2.23482 10.4365 2.58359 10.4491 2.95H7.55086C7.56349 2.58359 7.71457 2.23482 7.9747 1.9747C8.24662 1.70277 8.61544 1.55 9 1.55C9.38456 1.55 9.75338 1.70277 10.0253 1.9747ZM7.19688 1.19688C6.73046 1.6633 6.46338 2.2918 6.45049 2.95H1.5C1.35413 2.95 1.21424 3.00795 1.11109 3.11109C1.00795 3.21424 0.95 3.35413 0.95 3.5C0.95 3.64587 1.00795 3.78576 1.11109 3.88891C1.21424 3.99205 1.35413 4.05 1.5 4.05H2.50944L3.69833 14.3497C3.78414 15.0931 4.14023 15.779 4.69887 16.2769C5.2575 16.7748 5.97968 17.0499 6.728 17.05H11.272C12.0203 17.0499 12.7425 16.7748 13.3011 16.2769C13.8598 15.779 14.2159 15.0931 14.3017 14.3497L15.4906 4.05H16.5C16.6459 4.05 16.7858 3.99205 16.8889 3.88891C16.9921 3.78576 17.05 3.64587 17.05 3.5C17.05 3.35413 16.9921 3.21424 16.8889 3.11109C16.7858 3.00795 16.6459 2.95 16.5 2.95H11.5495C11.5366 2.2918 11.2695 1.6633 10.8031 1.19688C10.3249 0.71866 9.6763 0.45 9 0.45C8.3237 0.45 7.6751 0.71866 7.19688 1.19688ZM5.43068 15.4561C5.07347 15.1379 4.84569 14.6995 4.79067 14.2243C4.79067 14.2243 4.79067 14.2243 4.79067 14.2242L3.6171 4.05H14.3829L13.2093 14.2242C13.1543 14.6995 12.9265 15.1379 12.5693 15.4561C12.2121 15.7743 11.7504 15.9501 11.272 15.95H6.728C6.24961 15.9501 5.78789 15.7743 5.43068 15.4561ZM7.88891 6.61109C7.78576 6.50795 7.64587 6.45 7.5 6.45C7.35413 6.45 7.21424 6.50795 7.11109 6.61109C7.00795 6.71424 6.95 6.85413 6.95 7V13C6.95 13.1459 7.00795 13.2858 7.11109 13.3889C7.21424 13.4921 7.35413 13.55 7.5 13.55C7.64587 13.55 7.78576 13.4921 7.88891 13.3889C7.99205 13.2858 8.05 13.1459 8.05 13V7C8.05 6.85413 7.99205 6.71424 7.88891 6.61109ZM11.05 7C11.05 6.85413 10.9921 6.71424 10.8889 6.61109C10.7858 6.50795 10.6459 6.45 10.5 6.45C10.3541 6.45 10.2142 6.50795 10.1111 6.61109C10.0079 6.71424 9.95 6.85413 9.95 7V13C9.95 13.1459 10.0079 13.2858 10.1111 13.3889C10.2142 13.4921 10.3541 13.55 10.5 13.55C10.6459 13.55 10.7858 13.4921 10.8889 13.3889C10.9921 13.2858 11.05 13.1459 11.05 13V7Z"
              fill="#6D7080"
              stroke="#6D7080"
              strokeWidth="0.1"
            />
          </symbol>
        </svg>
      </div>
    </>
  );
};

const Tree = (props) => {
const treeValue = useSelector((redux) => redux.tree_structure).treeValue;

const getStyle = () => {
    let style = {};
    let level = props.level;
    if(treeValue?.widthChanges && treeValue.widthChanges[level]){
      style.width = 215 + treeValue.widthChanges[level];
    }
    if(treeValue?.widthChanges && treeValue.widthChanges[level-1]){
        style.left = 215 + treeValue.widthChanges[level-1];
    }
    style.height = props.maxHeight;
   return style;
}

  if (props.treeValue?.length > 0) {
    return (
      <ul role="tree" style={getStyle()}>
        <ReactTooltip delayHide={100} delayShow={200} delayUpdate={100} className="tooltip"></ReactTooltip>
        {props.treeValue.map((asset, index) => {
          return <TreeNode node={asset} index={index} isElouquaSettingPage = {props.isElouquaSettingPage} level={props.level} maxHeight={props.maxHeight}/>;
        })}
        <TreeResizeBar level={props.level} minWidth={215}/>
      </ul>
    );
  }
};

const TreeNode = (props) => {
  const treeValueRedux = useSelector((redux) => redux.tree_structure).treeValue;
  const projectAssetType = useSelector((redux) => redux.asset_type_for_project_creation).value;
  const selectedTreeData = useSelector((redux) => redux.tree_structure).selectedTreeData;
  const bootstrapData = useSelector((redux) => redux.customer_bootstrap_data).value;
  const dispatch = useDispatch();

  const onTreeNodeSelect = (e) => {
    if (
      props.node.type === Constants.FOLDER ||
      props.node.assetType === Constants.FOLDER ||
      props.node.assetType === Constants.VIDEO ||
      props.node.assetType === Constants.CAMPAIGN ||
      props.node.assetType === Constants.BLOG_SMALL ||
      props.node.assetType === Constants.STREAMS_CAMEL
    ) {
      jQuery("#" + props.node.id).trigger("focus")
      //jQuery(e).parents("li").addClass("active");
      jQuery(e.target.parentElement.parentElement.parentElement).parents("li").addClass("active");
      dispatch(setTreeLoading(true));
      dispatch(updateSelectedTreeNode(props.node));
    }
    dispatch(updateWidthChanges(getTreeWidthChanges()));
  };

  const onTreeNodeCheck = (e, node) => {
    let cloneNode = JSON.parse(JSON.stringify(node));
    if (e.target.checked) {
      jQuery(e.target).prop("checked", true);
      cloneNode.checked = true;

      if (props.isElouquaSettingPage && props.isElouquaSettingPage === 'true' && selectedTreeData?.length > 0) {
        selectedTreeData.map(data => dispatch(removeFromSelectedTreeData(data)))
      }
      dispatch(addToSelectedTreeData(cloneNode));
      if(bootstrapData?.features?.ASSET_VALIDATION) {
        dispatch(updateReadyForValidation(false));
      }
      dispatch(updateValidationErrors([]));
    } else {
      jQuery(e.target).prop("checked", false);
      cloneNode.checked = false;
      dispatch(removeFromSelectedTreeData(cloneNode));
    }
    dispatch(updateWidthChanges(getTreeWidthChanges()));
    jQuery("#" + props.node.id).trigger("focus")
  };

  let svgIcon;
  if (treeValueRedux.contentType === "MarketoRest" && props.node.level === 0) {
    svgIcon = "#level-first";
  } else {
    svgIcon = "#folder-icon";
  }

  let SVG;
  if (treeValueRedux.contentType === "MarketoRest" && props.node.level === 0) {
    SVG = (
      <>
        <svg fill="#697b90" className="folder-icon level-first-circle" width="18" height="16">
          <use href="#level-first"></use>
        </svg>
        <svg className="folder-icon open-folder-icon level-first-circle" width="18" height="16">
          <use href="#level-first"></use>
        </svg>
      </>
    );
  } else {
    SVG = (
      <>
        <svg className="folder-icon" width="18" height="16">
          <use href="#folder-icon"></use>
        </svg>
        <svg className="folder-icon open-folder-icon" width="18" height="14">
          <use href="#open-folder-icon"></use>
        </svg>
      </>
    );
  }

  let STRONG_TAG;
  if (props.node.type === Constants.LANDINGPAGE || props.node.assetType === Constants.LANDING_PAGE) {
    STRONG_TAG = <strong className="folder-icon-bg regular-ip-icon" />;
  } else if (props.node.type === Constants.EMAIL || props.node.assetType === Constants.EMAIL) {
    STRONG_TAG = <strong className="folder-icon-bg" />;
  } else if (props.node.type === Constants.FORM || props.node.assetType === Constants.FORM) {
    STRONG_TAG = <strong className="folder-icon-bg" />;
  } else {
    STRONG_TAG = <strong className="folder-icon-bg regular-ip-icon" />;
  }

  const hasChild = props.node?.children?.length > 0 ? true : false;

  return (

    <li role="treeitem" aria-label="first submenu" data-tree-root="deque-tree-root" tabIndex="0" id={props.node.id} 
    className={props.node?.selected === true ? "active" : ""}>
      <div className="flex justify-align">
        {(() => {
          if (
            props.node.type === Constants.LANDINGPAGE ||
            props.node.type === Constants.EMAIL ||
            props.node.type === Constants.FORM ||
            props.node.assetType === Constants.LANDING_PAGE ||
            props.node.assetType === Constants.EMAIL ||
            props.node.assetType === Constants.FORM ||
            props.node.assetType === Constants.CAPTIONS ||
            props.node.assetType === Constants.CAPTIONS_CAMEL ||
            props.node.type === Constants.EMAIL_HEADER_CAMEL_CASE ||
            props.node.type === Constants.EMAIL_FOOTER_CAMEL_CASE ||
            props.node.assetType === Constants.BLOG_POST_SMALL
          ) {
            return (
              <div className="form-check" data-tip={props.node[treeValueRedux.displayName]}>

                <input className="form-check-input" type="checkbox" name="checkbox" value="" id={props.node.id}
                onChange={(e) => onTreeNodeCheck(e, props.node)} disabled={props.node?.disabled === true} defaultChecked={props.node?.checked === true}/>

                <label className="form-check-label" htmlFor={props.node.id}>
                  <span>{props.node[treeValueRedux.displayName]}</span>
                </label>
              </div>
            );
          } else if (projectAssetType === Constants.PROGRAM && props.node.assetType === Constants.FOLDER && props.node.programOrChild && isMarketingProgram(props.node)) {
            return (
              <div className="left flex newprogram-tree" data-tip={props.node[treeValueRedux.displayName]}>
                <div className="form-check">

                  <input className="form-check-input" type="checkbox" name="checkbox" value="" id={props.node.id} disabled={props.node?.disabled === true}
                  onChange={(e) => onTreeNodeCheck(e, props.node)} defaultChecked={props.node?.checked === true} />

                  <label className="form-check-label" htmlFor={props.node.id}></label>
                </div>
                <svg className="folder-icon" width="18" height="16">
                  <use href="#folder-icon"></use>
                </svg>
                <svg className="folder-icon open-folder-icon" width="18" height="14">
                  <use href="#open-folder-icon"></use>
                </svg>
                <div className="div-ellipsis" onClick={(e) => onTreeNodeSelect(e)}>
                  <span>{props.node[treeValueRedux.displayName]}</span>
                  <svg className={treeValueRedux.selectedTreeNode?.selected ? "active tree-arrow-icon" : "tree-arrow-icon"} width="8" height="12">
                    <use href="#arrow"></use>
                  </svg>
                </div>
              </div>
            );
          } else if (
            props.node.type === Constants.FOLDER ||
            props.node.assetType === Constants.FOLDER ||
            props.node.assetType === Constants.VIDEO ||
            props.node.assetType === Constants.CAMPAIGN ||
            props.node.assetType === Constants.BLOG_SMALL ||
            props.node.assetType === Constants.STREAMS_CAMEL
          ) {
            return (
              <div className="left flex" onClick={(e) => onTreeNodeSelect(e)} data-tip={props.node[treeValueRedux.displayName]}>
                {SVG}
                <span>{props.node[treeValueRedux.displayName]}</span>
                <svg className={treeValueRedux.selectedTreeNode?.selected ? "active tree-arrow-icon" : "tree-arrow-icon"} width="8" height="12">
                  <use href="#arrow"></use>
                </svg>
              </div>
            );
          }
        })()}
      </div>
      {hasChild && treeValueRedux.selectedTreeNode?.selected && <Tree treeValue={props.node.children} level={props.level+1} maxHeight={props.maxHeight}/>}
    </li>
  );
};

const getTreeWidthChanges = () => {
  let tree = jQuery('.folder-hierarchy-block>ul');
  let widthChanges = [];
  while(tree.length > 0){
    let node = tree.get(0);
    let diff = parseInt(getComputedStyle(node).width, 10) - 215;
    widthChanges.push(diff);
    tree = tree.find('li>ul');
  }
  return widthChanges;
}

const calTreeMaxHeight = (treeData, unitHeight) => {
    if(!treeData)
        return 0;
    let maxHeight = treeData.length > 0 ? Math.ceil(treeData.length * unitHeight) : 0;
    for(let i=0; i<treeData.length; i++){
        let height = 0;
        if(treeData[i].children?.length > 0){
            height = calTreeMaxHeight(treeData[i].children, unitHeight);
        }
        if(height > maxHeight){
            maxHeight = height;
        }
    }
    return maxHeight;
}

export default TreeView;
